import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { DeleteBookingModal } from "../Modals/DeleteBookingModal";
import BookingDataService from "../../services/Booking";
import getBookingFormattedDate, {
  convertTo12HourFormat,
} from "../../Config/Booking";
export const SingleProvisionalBookingRow = ({ props, func, id }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];
  const {
    booking_id,
    booking_date,
    booking_time,
    booking_display,
    session_display,
    session_date,
    lead_information: { email, first_name, last_name },
    expert_information: { full_name, role },
    payment_information: { amount, payment_id },
    cart_information: { promocode },
    subscription: {
      subscription_sequence,
      session_count,
      subscription_booking_id,
    },
    session_time,
    booking_status,
    booking_type,
    post_session_status,
    wix_booking_id,
    createdAt,
    code,
  } = props;
  const navigate = useNavigate();
  const [modal, setModal] = useState("");

  const [approved, setApproved] = useState(props.is_approved ? true : false);
  const approveBooking = (status: any) => {
    BookingDataService.approvedBooking(booking_id, String(status))
      .then((res) => {
        setApproved(!approved);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  // useEffect(() => {
  //   approveExpert();
  // }, [approvedStatus]);

  return (
    <tr>
      {userControls.includes("bookingEditing") && (
        <td>
          <div
            className="edit-icon"
            onClick={() => navigate(`/provisional/bookings/edit/${booking_id}`)}
          >
            <BsPencil />
          </div>
        </td>
      )}
      <td>
        {wix_booking_id && (
          <div
            style={{
              color: "#f48a0f",
              fontWeight: "bold",
              fontSize: "12px",
              width: "80px",
            }}
          >
            WIX
          </div>
        )}
        <div>{booking_id}</div>
      </td>
      <td>
        {first_name} {last_name}
      </td>
      <td>{full_name}</td>
      <td>
        {booking_display ? (
          <div>{booking_display}</div>
        ) : (
          <>
            <div>{getBookingFormattedDate(booking_date)}</div>
            <div>{convertTo12HourFormat(booking_time)}</div>
          </>
        )}
      </td>
      <td>
        {session_display ? (
          <div>{session_display}</div>
        ) : (
          <>
            <div>{getBookingFormattedDate(session_date)}</div>
            <div> {session_time}</div>
          </>
        )}
      </td>
      <td>{booking_type}</td>
      <td> {booking_status} </td>
      <td>{post_session_status}</td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/bookings/view/${booking_id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>
        {userControls.includes("provisionalBookingApproval") && (
          <div className="d-flex align-items-center">
            <button
              type="button"
              // className={approv ? "disabledButton" : "btn"}
              onClick={() => {
                approveBooking(!approved);
              }}
              // disabled={approvedStatus}
              style={
                approved
                  ? { color: "#327171", fontWeight: "bolder" }
                  : {
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "10px",
                      width: "68px",
                    }
              }
            >
              {approved ? "Approved" : "Not Approved"}
            </button>
          </div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>

      {modal === "deletemodal" && (
        <DeleteBookingModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={booking_id}
        />
      )}
      {/* AddCommentModal */}
    </tr>
  );
};

// /SingleProvisionalBookingRow
